module.exports = __webpack_public_path__ + "img/culture_07.1bc4024c.png";